/* eslint-disable react-hooks/exhaustive-deps */
import { Tabs } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTER } from '../../../constants/router';
import { useTranslation } from 'react-i18next';
import useQuery from '../../../util/useQuery';
import SearchBar from '../../../components/Shared/searchbar/SearchBar';
import Tab1 from './Tab1';
import Tab2 from './Tab2';
import Tab3 from './Tab3';
import Tab4 from './Tab4';
import DayLeftToolTip from '../../../components/Shared/tooltip/dayleft';
import ListCard from './components/ListCard';
import GlobalService from '../../../services/Global.service';
import CustomizeBannerService from './../../../services/CustomizeBanner.service';
import DataFlowService from '../../../services/DataFlow.service';
import MyTaskService from '../../../services/MyTask.service';
const { TabPane } = Tabs;

export default function MyTaskList() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const params = useQuery();

    const [requestType, setRequestType] = useState([]);
    const [stateList, setStateList] = useState();
    const [domainList, setDomainList] = useState();
    const [dsList, setDSList] = useState();
    const [stateId, setStateId] = useState();
    const [statusFollowUpList, setStatusFollowUpList] = useState();
    const [statusFollowUpId, setStatusFollowUpId] = useState();
    const [statusRequestDoneList, setStatusRequestDoneList] = useState();
    const [statusRequestDoneId, setStatusRequestDoneId] = useState();

    const [cardData, setCardData] = useState();
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 10,
        total: 0,
    });
    const [loading, setLoading] = useState(true);
    const [firstLoad, setFirstLoad] = useState(true);
    const [isUseInventory, setIsUseInventory] = useState();
    const [tabCountTodoList, setTabCountTodoList] = useState(0);
    const [tabCountFollowUp, setTabCountFollowUp] = useState(0);
    const [tabCountOperationDone, setTabCountOperationDone] = useState(0);
    const [tabCountRequestDone, setTabCountRequestDone] = useState(0);

    useEffect(() => {
        const getRequestTypeDropdown = async () => {
            try {
                const { data } = await GlobalService.getRequestType();
                if (data?.resultCode === 1) {
                    const items = [];
                    items.push({
                        id: '',
                        value:
                            i18n.language === 'en'
                                ? 'All Request Type'
                                : 'คำขอใช้สิทธิทั้งหมด',
                    });
                    data?.resultData?.forEach((element) => {
                        items.push({
                            value:
                                i18n.language === 'en'
                                    ? element.requestTypeShortNameEn
                                    : element.requestTypeShortName,
                            id: element.requestTypeId,
                        });
                    });
                    setRequestType(items);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getRequestTypeDropdown();
    }, [i18n.language]);

    useEffect(() => {
        const getDomainDropdown = async () => {
            try {
                const { data } =
                    await CustomizeBannerService.getDomainListByCompany({
                        p: 1,
                        ps: 10000,
                        s: 'domainName',
                        sd: 'DESC',
                    });
                if (data?.resultCode === 1) {
                    const items = [];
                    items.push({
                        id: '',
                        value:
                            i18n.language === 'en'
                                ? 'All Domain'
                                : 'โดเมนทั้งหมด',
                    });
                    data?.resultData.result?.forEach((element) => {
                        items.push({
                            value: element.domainName,
                            id: element.domainId,
                        });
                    });
                    setDomainList(items);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDomainDropdown();
    }, [i18n.language]);

    useEffect(() => {
        const getDSDropdown = async () => {
            let lang = i18n.language;
            try {
                const { data } = await GlobalService.getDs();
                if (data?.resultCode === 1) {
                    const items = [];
                    items.push({
                        id: '',
                        value:
                            i18n.language === 'en'
                                ? 'All DS Type'
                                : 'ประเภทเจ้าของข้อมูลทั้งหมด',
                    });
                    data?.resultData?.dataSubjectType?.forEach((element) => {
                        items.push({
                            value:
                                lang === 'en' ? element.nameEn : element.nameTh,
                            id: element.id,
                        });
                    });
                    setIsUseInventory(data?.resultData?.isUsedInventory);
                    setDSList(items);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getDSDropdown();
    }, [i18n.language]);

    useEffect(() => {
        const getStateDropdown = async () => {
            try {
                const { data } = await GlobalService.getStateDropdown();
                if (data?.resultCode === 1) {
                    const items = [];
                    data?.resultData?.forEach((element) => {
                        items.push({
                            value: element.stateName,
                            id: element.stateId,
                        });
                    });
                    const itemsId = [];
                    data?.resultData?.forEach((element) => {
                        itemsId.push(element.stateId);
                    });
                    setStateList(items);
                    setStateId(itemsId);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStateDropdown();
    }, []);

    useEffect(() => {
        const getStatusDropdown = async () => {
            try {
                const { data } = await DataFlowService.getStatus({
                    type: 'my-task',
                });
                if (data?.resultCode === 1) {
                    const items = [];
                    data?.resultData?.forEach((element) => {
                        if (
                            element.nameEn === 'Verified' ||
                            element.nameEn === 'Preparing' ||
                            element.nameEn === 'In Progress'
                        ) {
                            items.push({
                                value:
                                    i18n.language === 'en'
                                        ? element.nameEn
                                        : element.nameTh,
                                id: element.statusId,
                            });
                        }
                    });
                    const itemsId = [];
                    data?.resultData?.forEach((element) => {
                        if (
                            element.nameEn === 'Verified' ||
                            element.nameEn === 'Preparing' ||
                            element.nameEn === 'In Progress'
                        ) {
                            itemsId.push(element.statusId);
                        }
                    });
                    setStatusFollowUpList(items);
                    setStatusFollowUpId(itemsId);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatusDropdown();
    }, [i18n.language]);

    useEffect(() => {
        const getStatusDropdown = async () => {
            try {
                const { data } = await DataFlowService.getStatus({
                    type: 'my-task',
                });
                if (data?.resultCode === 1) {
                    const items = [];
                    data?.resultData?.forEach((element) => {
                        if (
                            element.nameEn === 'Reject' ||
                            element.nameEn === 'Done'
                        ) {
                            items.push({
                                value:
                                    i18n.language === 'en'
                                        ? element.nameEn
                                        : element.nameTh,
                                id: element.statusId,
                            });
                        }
                    });
                    const itemsId = [];
                    data?.resultData?.forEach((element) => {
                        if (
                            element.nameEn === 'Reject' ||
                            element.nameEn === 'Done'
                        ) {
                            itemsId.push(element.statusId);
                        }
                    });
                    setStatusRequestDoneList(items);
                    setStatusRequestDoneId(itemsId);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatusDropdown();
    }, [i18n.language]);

    // Reset Total Count
    useEffect(() => {
        const getRequestDone = async () => {
            const object = {
                requestId: null,
                statusId:
                    '6a1166ff495b11ed867dfa163e89e3c8,6f17a0f1495b11ed867dfa163e89e3c8',
                requestTypeId: null,
                dsTypeId: null,
                dsTypeKeyword: null,
                domainId: null,
                p: 1,
                ps: 10,
                sd: 'DESC',
            };
            try {
                const { data } = await MyTaskService.getMyTaskRequestDone(
                    object
                );
                setLoading(false);
                // setTabCount({
                //    ...tabCount,
                //    tabCountRequestDone: data?.resultData?.total,
                // });
                setTabCountRequestDone(data?.resultData?.total);
            } catch (err) {
                setLoading(false);
                console.log(err);
            }
        };
        const getOperationDone = async () => {
            const object = {
                requestId: null,
                requestTypeId: null,
                dsTypeId: null,
                dsTypeKeyword: null,
                domainId: null,
                p: 1,
                ps: 10,
                sd: 'DESC',
            };
            try {
                const { data } = await MyTaskService.getMyTaskOperationDone(
                    object
                );
                setLoading(false);
                setTabCountOperationDone(data?.resultData?.total);
            } catch (err) {
                setLoading(false);
                console.log(err);
            }
        };
        const getFollowUp = async () => {
            const object = {
                stateId: null,
                statusId:
                    '5f486ec1495b11ed867dfa163e89e3c8,63ba7d66495b11ed867dfa163e89e3c8,66d85e5e495b11ed867dfa163e89e3c8',
                requestTypeId: null,
                dsTypeId: null,
                dsTypeKeyword: null,
                domainId: null,
                p: 1,
                ps: 10,
                sd: 'ASC',
            };
            try {
                const { data } = await MyTaskService.getMyTaskFollowUp(object);
                setLoading(false);
                setTabCountFollowUp(data?.resultData?.total);
            } catch (err) {
                setLoading(false);
                console.log(err);
            }
        };
        const getTodoList = async () => {
            const object = {
                stateId: stateId?.join(','),
                statusId: null,
                requestId: null,
                requestTypeId: null,
                dsTypeId: null,
                dsTypeKeyword: null,
                domainId: null,
                p: 1,
                ps: 10,
                sd: 'ASC',
            };
            try {
                const { data } = await MyTaskService.getMyTaskTodoList(object);
                setLoading(false);
                setTabCountTodoList(data?.resultData?.total);
            } catch (err) {
                setLoading(false);
            }
        };
        getOperationDone();
        getTodoList();
        getFollowUp();
        getRequestDone();
    }, [params.get('tab'), statusFollowUpId, stateId, statusRequestDoneId]);
    return (
        <>
            <div className="title ">{t('My Task')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Subject 360')} /{' '}
                </span>
                <span> {t('My Task')}</span>
            </div>
            <div className="content_">
                <div>
                    {(!params.get('tab') || params.get('tab') === '1') && (
                        <TodoListSearch
                            stateList={stateList}
                            stateId={stateId}
                            requestType={requestType}
                            domainList={domainList}
                            dsList={dsList}
                            isUseInventory={isUseInventory}
                            setCardData={setCardData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setTabCountTodoList={setTabCountTodoList}
                            tabCountTodoList={tabCountTodoList}
                            loading={loading}
                            setLoading={setLoading}
                            firstLoad={firstLoad}
                            setFirstLoad={setFirstLoad}
                        />
                    )}
                    {params.get('tab') === '2' && (
                        <FollowUpSearch
                            statusFollowUpList={statusFollowUpList}
                            statusFollowUpId={statusFollowUpId}
                            requestType={requestType}
                            domainList={domainList}
                            dsList={dsList}
                            isUseInventory={isUseInventory}
                            setCardData={setCardData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setTabCountFollowUp={setTabCountFollowUp}
                            loading={loading}
                            setLoading={setLoading}
                            setFirstLoad={setFirstLoad}
                            firstLoad={firstLoad}
                        />
                    )}
                    {params.get('tab') === '3' && (
                        <OperationDoneSearch
                            stateList={stateList}
                            requestType={requestType}
                            domainList={domainList}
                            dsList={dsList}
                            isUseInventory={isUseInventory}
                            setCardData={setCardData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setTabCountOperationDone={setTabCountOperationDone}
                            loading={loading}
                            setLoading={setLoading}
                            setFirstLoad={setFirstLoad}
                            firstLoad={firstLoad}
                        />
                    )}
                    {params.get('tab') === '4' && (
                        <RequestDoneSearch
                            statusRequestDoneList={statusRequestDoneList}
                            statusRequestDoneId={statusRequestDoneId}
                            requestType={requestType}
                            domainList={domainList}
                            dsList={dsList}
                            isUseInventory={isUseInventory}
                            setCardData={setCardData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            setTabCountRequestDone={setTabCountRequestDone}
                            loading={loading}
                            setLoading={setLoading}
                            setFirstLoad={setFirstLoad}
                            firstLoad={firstLoad}
                        />
                    )}
                </div>
                <div className="w-full">
                    <div className="flex py-2">
                        <div className="flex-1">
                            <div className="text-xl font-medium">
                                {t('My Task List')}
                            </div>
                            <div className="text-xs font-normal text-gray-PHX mt-1">
                                {t(
                                    'เมนูสำหรับปฏิบัติงานตามคำขอใช้สิทธิของเจ้าของข้อมูล'
                                )}
                            </div>
                        </div>
                        <DayLeftToolTip />
                    </div>
                    <div>
                        <Tabs
                            className="tabs bg-white p-4 rounded-md"
                            onChange={(key) => {
                                // setLoading(true);
                                // btnClear();
                                navigate(`${ROUTER.DS_360.MY_TASK}?tab=${key}`);
                                setLoading(true);
                                setCurrentPage({
                                    ...currentPage,
                                    page: 1,
                                });
                            }}
                            activeKey={params.get('tab') || '1'}
                        >
                            <TabPane
                                tab={`${t(
                                    'MyTask.TodoList'
                                )} (${tabCountTodoList})`}
                                key={1}
                            >
                                <Tab1 tabCount={tabCountTodoList} />
                            </TabPane>
                            <TabPane
                                tab={`${t(
                                    'MyTask.FollowUp'
                                )} (${tabCountFollowUp})`}
                                key={2}
                            >
                                <Tab2 tabCount={tabCountFollowUp} />
                            </TabPane>
                            <TabPane
                                tab={`${t(
                                    'MyTask.OperationDone'
                                )} (${tabCountOperationDone})`}
                                key={3}
                            >
                                <Tab3 tabCount={tabCountOperationDone} />
                            </TabPane>
                            <TabPane
                                tab={`${t(
                                    'MyTask.RequestDone'
                                )} (${tabCountRequestDone})`}
                                key={4}
                            >
                                <Tab4 tabCount={tabCountRequestDone} />
                            </TabPane>
                        </Tabs>
                        <div className="pt-4">
                            {/* Mock Data */}

                            {(!params.get('tab') ||
                                params.get('tab') === '1') && (
                                <ListCard
                                    dataSource={cardData || null}
                                    onChangePage={setCurrentPage}
                                    currentPage={currentPage}
                                    loading={loading}
                                    setLoading={setLoading}
                                    requestType={requestType}
                                />
                            )}
                            {params.get('tab') === '2' && (
                                <ListCard
                                    dataSource={cardData || null}
                                    onChangePage={setCurrentPage}
                                    currentPage={currentPage}
                                    loading={loading}
                                    setLoading={setLoading}
                                    requestType={requestType}
                                />
                            )}
                            {params.get('tab') === '3' && (
                                <ListCard
                                    dataSource={cardData || null}
                                    onChangePage={setCurrentPage}
                                    currentPage={currentPage}
                                    loading={loading}
                                    setLoading={setLoading}
                                    requestType={requestType}
                                />
                            )}
                            {params.get('tab') === '4' && (
                                <ListCard
                                    dataSource={cardData || null}
                                    onChangePage={setCurrentPage}
                                    currentPage={currentPage}
                                    loading={loading}
                                    setLoading={setLoading}
                                    requestType={requestType}
                                />
                            )}
                            {/* <ListCard dataSource={data?.resultData} /> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const TodoListSearch = ({
    stateList,
    stateId,
    requestType,
    domainList,
    dsList,
    isUseInventory,
    setCardData,
    setCurrentPage,
    currentPage,
    setTabCountTodoList,
    loading,
    setLoading,
    firstLoad,
    setFirstLoad,
}) => {
    const { t } = useTranslation();
    const dsType = isUseInventory
        ? {
              label: t('MyTask.DSType'),
              placeholder: t('Select DS Type'),
              name: 'dsTypeId',
              type: 'Select',
              defaultValue: '',
              option: dsList,
          }
        : {
              label: t('MyTask.DSType'),
              placeholder: t('MyTask.SearchDSType'),
              name: 'dsTypeKeyword',
              type: 'Input',
          };

    const [searchValue, setSearchValue] = useState({});

    const searchTodoList = async (payload, pageValue) => {
        //ใส่ trim ด้วย
        const object = {
            stateId: payload?.stateId
                ? payload?.stateId?.join(',')
                : stateId?.join(','),
            statusId: null,
            requestId: payload?.requestId || null,
            requestTypeId: payload?.requestTypeId || null,
            dsTypeId: payload?.dsTypeId || null,
            dsTypeKeyword: payload?.dsTypeKeyword || null,
            domainId: payload?.domainId || null,
            p: pageValue.page ? pageValue.page : 1,
            ps: pageValue.pageSize ? pageValue.pageSize : 10,
            sd: 'ASC',
        };
        setCardData();
        try {
            const { data } = await MyTaskService.getMyTaskTodoList(object);
            setLoading(false);
            setCardData(data?.resultData?.result || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
            setTabCountTodoList(data?.resultData?.total);
        } catch (err) {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (firstLoad && stateId) {
            setFirstLoad(false);
            searchTodoList(searchValue, currentPage);
        }
    }, [stateId]);
    useEffect(() => {
        if (loading) {
            const pageValue = {
                ...currentPage,
                page: 1,
            };
            searchTodoList(searchValue, pageValue);
        }
    }, [searchValue]);

    useEffect(() => {
        if (loading) {
            searchTodoList(searchValue, currentPage);
        }
    }, [currentPage]);

    return (
        <SearchBar
            item={[
                {
                    label: t('MyTask.Process'),
                    name: 'stateId',
                    type: 'CheckboxByKey',
                    option: stateList,
                    initialValue: stateId,
                },
                {
                    label: t('MyTask.RequestID'),
                    placeholder: t('Search Request ID'),
                    name: 'requestId',
                    type: 'Input',
                    defaultValue: '',
                    option: [],
                },
                {
                    label: t('MyTask.RequestType'),
                    placeholder: t('Select Request Type'),
                    name: 'requestTypeId',
                    type: 'Select',
                    defaultValue: '',
                    option: requestType,
                },
                dsType,
                {
                    label: t('MyTask.Domain'),
                    placeholder: t('Select Domain'),
                    name: 'domainId',
                    type: 'Select',
                    defaultValue: '',
                    option: domainList,
                },
            ]}
            onClear={() => {
                setLoading(true);
                setSearchValue({
                    stateId: stateId,
                });
                setCurrentPage({
                    ...currentPage,
                    page: 1,
                });
            }}
            onFinish={(e) => {
                setLoading(true);
                setSearchValue({
                    ...e,
                });
            }}
        />
    );
};
const FollowUpSearch = ({
    statusFollowUpList,
    statusFollowUpId,
    requestType,
    domainList,
    dsList,
    isUseInventory,
    setCardData,
    setCurrentPage,
    currentPage,
    setTabCountFollowUp,
    loading,
    setLoading,
    setFirstLoad,
    firstLoad,
}) => {
    const { t } = useTranslation();
    const dsType = isUseInventory
        ? {
              label: t('MyTask.DSType'),
              placeholder: t('Select DS Type'),
              name: 'dsTypeId',
              type: 'Select',
              defaultValue: '',
              option: dsList,
          }
        : {
              label: t('MyTask.DSType'),
              placeholder: t('MyTask.SearchDSType'),
              name: 'dsTypeKeyword',
              type: 'Input',
          };
    const [searchValue, setSearchValue] = useState({});
    const searchFollowUp = async (payload, pageValue) => {
        const object = {
            requestId: payload?.requestId || null,
            statusId: payload?.statusId
                ? payload?.statusId.join(',')
                : statusFollowUpId?.join(','),
            requestTypeId: payload?.requestTypeId || null,
            dsTypeId: payload?.dsTypeId || null,
            dsTypeKeyword: null,
            domainId: payload?.domainId || null,
            p: pageValue.page ? pageValue.page : 1,
            ps: pageValue.pageSize ? pageValue.pageSize : 10,
            sd: 'ASC',
        };
        setCardData();
        try {
            const { data } = await MyTaskService.getMyTaskFollowUp(object);
            setLoading(false);
            setCardData(data?.resultData?.result || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
            setTabCountFollowUp(data?.resultData?.total);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            const pageValue = {
                ...currentPage,
                page: 1,
            };
            searchFollowUp(searchValue, pageValue);
        }
    }, [searchValue]);
    useEffect(() => {
        if (loading) {
            searchFollowUp(searchValue, currentPage);
        }
    }, [currentPage]);

    useEffect(() => {
        if (firstLoad && statusFollowUpId) {
            setFirstLoad(false);
            searchFollowUp(searchValue, currentPage);
        }
    }, [statusFollowUpId]);
    return (
        <SearchBar
            item={[
                {
                    label: t('MyTask.RequestStatus'),
                    name: 'statusId',
                    type: 'CheckboxByKey',
                    option: statusFollowUpList,
                    initialValue: statusFollowUpId,
                },
                {
                    label: t('MyTask.RequestID'),
                    placeholder: t('MyTask.SearchRequestID'),
                    name: 'requestId',
                    type: 'Input',
                    defaultValue: '',
                    option: [],
                },
                {
                    label: t('MyTask.RequestType'),
                    placeholder: t('MyTask.SelectRequestType'),
                    name: 'requestTypeId',
                    type: 'Select',
                    defaultValue: '',
                    option: requestType,
                },
                dsType,
                {
                    label: t('Domain'),
                    placeholder: t('Select Domain'),
                    name: 'domainId',
                    type: 'Select',
                    defaultValue: '',
                    option: domainList,
                },
            ]}
            onClear={() => {
                setLoading(true);
                setSearchValue({
                    statusId: statusFollowUpId,
                });
                setCurrentPage({
                    ...currentPage,
                    page: 1,
                });
            }}
            onFinish={(e) => {
                setLoading(true);
                setSearchValue({
                    ...e,
                });
            }}
        />
    );
};
const OperationDoneSearch = ({
    requestType,
    domainList,
    dsList,
    isUseInventory,
    setCardData,
    setCurrentPage,
    currentPage,
    setTabCountOperationDone,
    loading,
    setLoading,
    setFirstLoad,
    firstLoad,
}) => {
    const { t } = useTranslation();
    const dsType = isUseInventory
        ? {
              label: t('MyTask.DSType'),
              placeholder: t('Select DS Type'),
              name: 'dsTypeId',
              type: 'Select',
              defaultValue: '',
              option: dsList,
          }
        : {
              label: t('MyTask.DSType'),
              placeholder: t('MyTask.SearchDSType'),
              name: 'dsTypeKeyword',
              type: 'Input',
          };

    const [searchValue, setSearchValue] = useState({});

    const searchOperationDone = async (payload, pageValue) => {
        const object = {
            requestId: payload?.requestId || null,
            requestTypeId: payload?.requestTypeId || null,
            dsTypeId: payload?.dsTypeId || null,
            dsTypeKeyword: null,
            domainId: payload?.domainId || null,
            p: pageValue?.page ? pageValue?.page : 1,
            ps: pageValue?.pageSize ? pageValue?.pageSize : 10,
            sd: 'DESC',
        };
        setCardData();
        try {
            const { data } = await MyTaskService.getMyTaskOperationDone(object);
            setLoading(false);
            setCardData(data?.resultData?.result || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
            setTabCountOperationDone(data?.resultData?.total);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };
    useEffect(() => {
        if (loading) {
            const pageValue = {
                ...currentPage,
                page: 1,
            };
            searchOperationDone(searchValue, pageValue);
        }
    }, [searchValue]);
    useEffect(() => {
        if (loading) {
            searchOperationDone(searchValue, currentPage);
        }
    }, [currentPage]);

    useEffect(() => {
        if (firstLoad) {
            setFirstLoad(false);
            searchOperationDone(searchValue, currentPage);
        }
    }, []);
    return (
        <SearchBar
            item={[
                {
                    label: t('Request ID'),
                    placeholder: t('Search Request ID'),
                    name: 'requestId',
                    type: 'Input',
                    defaultValue: '',
                    option: [],
                },
                {
                    label: t('Request Type'),
                    placeholder: t('Select Request Type'),
                    name: 'requestTypeId',
                    type: 'Select',
                    defaultValue: '',
                    option: requestType,
                },
                dsType,
                {
                    label: t('Domain'),
                    placeholder: t('Select Domain'),
                    name: 'domainId',
                    type: 'Select',
                    defaultValue: '',
                    option: domainList,
                },
            ]}
            onClear={() => {
                setLoading(true);
                setSearchValue({});
                setCurrentPage({
                    ...currentPage,
                    page: 1,
                });
            }}
            onFinish={(e) => {
                setLoading(true);
                setSearchValue({
                    ...e,
                });
            }}
        />
    );
};
const RequestDoneSearch = ({
    statusRequestDoneList,
    statusRequestDoneId,
    requestType,
    domainList,
    dsList,
    isUseInventory,
    setCardData,
    setCurrentPage,
    currentPage,
    setTabCountRequestDone,
    loading,
    setLoading,
    setFirstLoad,
    firstLoad,
}) => {
    const { t } = useTranslation();

    const dsType = isUseInventory
        ? {
              label: t('MyTask.DSType'),
              placeholder: t('Select DS Type'),
              name: 'dsTypeId',
              type: 'Select',
              defaultValue: '',
              option: dsList,
          }
        : {
              label: t('MyTask.DSType'),
              placeholder: t('MyTask.SearchDSType'),
              name: 'dsTypeKeyword',
              type: 'Input',
          };

    const [searchValue, setSearchValue] = useState({});

    const searchRequestDone = async (payload, pageValue) => {
        const object = {
            requestId: payload?.requestId || null,
            statusId: payload?.statusId
                ? payload?.statusId?.join(',')
                : statusRequestDoneId?.join(','),
            requestTypeId: payload?.requestTypeId || null,
            dsTypeId: payload?.dsTypeId || null,
            dsTypeKeyword: null,
            domainId: payload?.domainId || null,
            p: pageValue?.page ? pageValue?.page : 1,
            ps: pageValue?.pageSize ? pageValue?.pageSize : 10,
            sd: 'DESC',
        };
        setCardData();
        try {
            const { data } = await MyTaskService.getMyTaskRequestDone(object);
            setLoading(false);
            setCardData(data?.resultData?.result || []);
            setCurrentPage({
                page: data?.resultData.page,
                pageSize: data?.resultData.pageSize,
                total: data?.resultData.total,
            });
            setTabCountRequestDone(data?.resultData?.total);
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    };

    useEffect(() => {
        if (loading) {
            const pageValue = {
                ...currentPage,
                page: 1,
            };
            searchRequestDone(searchValue, pageValue);
        }
    }, [searchValue]);
    useEffect(() => {
        if (loading) {
            searchRequestDone(searchValue, currentPage);
        }
    }, [currentPage]);

    useEffect(() => {
        if (firstLoad && statusRequestDoneId) {
            setFirstLoad(false);
            searchRequestDone(searchValue, currentPage);
        }
    }, [statusRequestDoneId]);
    return (
        <SearchBar
            item={[
                {
                    label: t('MyTask.RequestStatus'),
                    name: 'statusId',
                    type: 'CheckboxByKey',
                    option: statusRequestDoneList,
                    initialValue: statusRequestDoneId,
                },
                {
                    label: t('MyTask.RequestID'),
                    placeholder: t('MyTask.SearchRequestID'),
                    name: 'requestId',
                    type: 'Input',
                    defaultValue: '',
                    option: [],
                },
                {
                    label: t('MyTask.RequestType'),
                    placeholder: t('MyTask.SelectRequestType'),
                    name: 'requestTypeId',
                    type: 'Select',
                    defaultValue: '',
                    option: requestType,
                },
                dsType,
                {
                    label: t('MyTask.Domain'),
                    placeholder: t('Select Domain'),
                    name: 'domainId',
                    type: 'Select',
                    defaultValue: '',
                    option: domainList,
                },
            ]}
            onClear={() => {
                setLoading(true);
                setSearchValue({
                    statusId: statusRequestDoneId,
                });
                setCurrentPage({
                    ...currentPage,
                    page: 1,
                });
            }}
            onFinish={(e) => {
                setLoading(true);
                setSearchValue({
                    ...e,
                });
            }}
        />
    );
};
